import React from "react";

import { Box } from "@mui/material";

export function VideoStatus({
  readyCount,
  status,
}: {
  readyCount: number;
  status: "ready" | "pending" | "failed";
}) {
  const backgroundColor = {
    ready: {
      backgroundColor: "#E8F5E8",
      color: "#2E7D32",
      borderColor: "#4CAF50",
    },
    pending: {
      backgroundColor: "#FFF3E0",
      color: "#E65100",
      borderColor: "#FFCC02",
    },
    failed: {
      backgroundColor: "#FFE5E5",
      color: "#D32F2F",
      borderColor: "#F44336",
    },
  };
  return (
    <Box
      sx={{
        backgroundColor: () => backgroundColor[status].backgroundColor,
        color: () => backgroundColor[status].color,
        border: 1,
        borderColor: () => backgroundColor[status].borderColor,
        px: { xs: 1, sm: 1.5 },
        py: { xs: 0.25, sm: 0.5 },
        borderRadius: 1.5,
        fontSize: { xs: "0.7rem", sm: "0.75rem" },
        fontWeight: 600,
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        whiteSpace: "nowrap",
      }}
    >
      {readyCount} {status}
    </Box>
  );
}
